import React from "react";

function IconMegaphone() {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 19">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.419 3.438a.656.656 0 0 1 .363.587v2.991c.517.246.875.773.875 1.384v.875c0 .61-.358 1.138-.875 1.384v2.99a.656.656 0 0 1-1.05.526L9.406 11.68H8.388l-.751 3.003a.656.656 0 0 1-.637.497h-.875a.656.656 0 0 1-.637-.815l.672-2.685h-.472a2.844 2.844 0 1 1 0-5.687h3.718L12.732 3.5a.656.656 0 0 1 .687-.062Zm-3.794 6.93c.142 0 .28.047.394.132l2.45 1.837v-7l-2.45 1.838a.656.656 0 0 1-.394.131H5.688a1.531 1.531 0 1 0 0 3.063h3.937Z"
      />
    </svg>
  );
}

export default IconMegaphone;
